import { EditFilled } from '@ant-design/icons';
import { Col, Form, InputNumber, Row, Space } from 'antd';
import { useState } from 'react';
import { useUpdateControlSettings } from './hooks/useControlSettings';
import { AntSwitch } from '@/common/ant-components/AntSwitch';
import { AntButton } from '@/common/ant-components/AntButton';
import DraggableModal from '@/common/ant-components/DraggableModal';

const EditControlSettings = ({ id, record, mutateAsync }) => {
  const [form] = Form.useForm();
  const [referenceId, setReferenceId] = useState(null);
  const [open, setOpen] = useState(false);

  const [data, setData] = useState(record);

  const showModal = async () => {
    try {
      setOpen(true);
      setReferenceId(id);
      form.setFieldsValue(record);
    } catch (error) {
      console.error('Error fetching version data:', error);
      setOpen(false);
    }
  };

  const closeModal = () => {
    setOpen(false);
  };

  const { mutateAsync: updateVersion, isPending } = useUpdateControlSettings();

  const onFinish = async (values) => {
    updateVersion(values, {
      onSuccess: () => {
        setOpen(false);
      },
      onError: (error) => {
        console.error('Error updating version:', error);
      },
    });
  };

  return (
    <>
      <div size="medium" className="edit tw-cursor-pointer" onClick={showModal}>
        <EditFilled color="blue" />
      </div>

      <DraggableModal
        open={open}
        onCancel={closeModal}
        width={500}
        title="Edit Control Settings"
        footer={null}
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="imageMaxCount"
                label="Image Max Count"
                className="username"
                rules={[
                  { required: true, message: 'Image max count is required' },
                ]}
              >
                <InputNumber
                  placeholder="Enter image limit count"
                  controls={false}
                  min={0}
                  max={15}
                  onChange={(e) => {
                    setData({
                      ...data,
                      imageMaxCount: e,
                    });
                  }}
                  className="tw-w-[100%]"
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <AntSwitch
                formProps={{
                  label: 'Is Upload Image',
                  name: 'showImage',
                  rules: [
                    {
                      required: true,
                      message: 'Is Upload Image is required',
                    },
                  ],
                }}
                className="username"
                onChange={(e) => {
                  setData({
                    ...data,
                    showImage: e,
                  });
                }}
              />
            </Col>
          </Row>

          <div style={{ textAlign: 'right', marginTop: '12px' }}>
            <Space size="large">
              <AntButton
                loading={isPending}
                type="primary"
                onClick={async () => {
                  await form.validateFields();
                  updateVersion(data, {
                    onSuccess: () => {
                      setOpen(false);
                      mutateAsync({ url: '/superadmin/control-settings/' });
                    },
                    onError: () => {},
                  });
                }}
              >
                Update
              </AntButton>
              <AntButton color="red" onClick={closeModal}>
                Cancel
              </AntButton>
            </Space>
          </div>
        </Form>
      </DraggableModal>
    </>
  );
};

export default EditControlSettings;
